import { render, staticRenderFns } from "./sponsor_user_edit.vue?vue&type=template&id=48b25300&scoped=true&"
import script from "./sponsor_user_edit.vue?vue&type=script&lang=js&"
export * from "./sponsor_user_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b25300",
  null
  
)

export default component.exports